/* Pouches LP education block - closed/open can swap.
   Hover devices (desktop): CSS handles the swap on :hover; this only loads the open image once the
   section is near, so the first hover is instant.
   Everything else: while the section is on screen the can alternates closed <-> open every
   data-pe-swap seconds; off screen it rests on the closed can and the timer stops. The open image
   is not requested at all until the section first comes near the viewport. */
(function(){
  var HOVER = window.matchMedia('(hover:hover) and (min-width:1024px)');

  function arm(media){
    if (media.__peArmed) return;
    media.__peArmed = 1;
    var pic = media.querySelector('.pe__pic--o');
    if (!pic) return;
    [].forEach.call(pic.querySelectorAll('[data-srcset]'), function(el){
      el.setAttribute('srcset', el.getAttribute('data-srcset'));
      el.removeAttribute('data-srcset');
    });
    var img = pic.querySelector('img[data-src]');
    if (img){ img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); }
  }

  function init(root){
    if (root.__pe) return;
    root.__pe = 1;
    var media = root.querySelector('[data-pe-media]');
    if (!media || !media.querySelector('.pe__pic--o')) return;
    var every = (parseFloat(root.getAttribute('data-pe-swap')) || 2) * 1000;
    var timer = null, visible = false;

    function stop(){
      if (timer){ clearInterval(timer); timer = null; }
      media.classList.remove('is-open');
    }
    function start(){
      if (timer || HOVER.matches || !visible) return;
      timer = setInterval(function(){ media.classList.toggle('is-open'); }, every);
    }
    function mode(){ if (HOVER.matches) stop(); else start(); }

    if (!('IntersectionObserver' in window)){
      arm(media); visible = true; start();
      return;
    }
    /* near: fetch the open image a little before it can be seen */
    new IntersectionObserver(function(es){
      es.forEach(function(e){ if (e.isIntersecting) arm(media); });
    }, { rootMargin: '300px 0px' }).observe(media);
    /* on screen: run the swap only while a third of the can is actually visible */
    new IntersectionObserver(function(es){
      es.forEach(function(e){
        visible = e.isIntersecting;
        if (visible) start(); else stop();
      });
    }, { threshold: 0.33 }).observe(media);

    if (HOVER.addEventListener) HOVER.addEventListener('change', mode); else if (HOVER.addListener) HOVER.addListener(mode);
    root.__peApi = { start: start, stop: stop, arm: function(){ arm(media); } };
  }

  function boot(){ [].forEach.call(document.querySelectorAll('[data-pe]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
